import React from 'react';
import { X } from 'lucide-react';

const DocumentViewer = ({ url, title, onClose }) => {
  if (!url) return null;

  const isImage = /\.(jpg|jpeg|png|gif|webp)(\?|$)/i.test(url);

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm animate-in fade-in duration-200">
      <div className="relative bg-white rounded-2xl shadow-2xl flex flex-col overflow-hidden w-full max-w-4xl max-h-[90vh]">
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100 shrink-0">
          <p className="text-sm font-black text-gray-700 truncate">{title || 'Document Preview'}</p>
          <button onClick={onClose} className="p-1.5 hover:bg-gray-100 rounded-lg transition-all text-gray-400 hover:text-gray-700">
            <X size={18} />
          </button>
        </div>
        <div className="flex-1 overflow-auto min-h-0">
          {isImage ? (
            <img src={url} alt={title} className="w-full h-full object-contain" />
          ) : (
            <iframe src={url} title={title} className="w-full h-full min-h-[70vh] border-0" sandbox="allow-scripts allow-same-origin allow-forms" />
          )}
        </div>
      </div>
    </div>
  );
};

export default DocumentViewer;
